// extracted by mini-css-extract-plugin
module.exports = {"contactStyle":"Contact_contactStyle__hJIu-","cardGroup":"Contact_cardGroup__3naR_","formStyle":"Contact_formStyle__1PRd9"};